<div class="login-shell">
  <!-- Brand panel with drifting gradient (hidden on small screens) -->
  <aside class="brand-panel">
    <img
      src="assets/images/banknbox-icon.svg"
      [attr.alt]="'login.logoAlt' | translate"
      class="brand-panel__icon"
    />

    <div class="brand-panel__content">
      <p class="brand-panel__portal">
        {{ "login.panel.product" | translate }}
        <span class="brand-panel__sep">|</span>
        {{ "login.panel.portal" | translate }}
      </p>
      <h1 class="brand-panel__title">{{ "login.panel.title" | translate }}</h1>
      <hr class="brand-panel__rule" />
      <p class="brand-panel__text">
        {{ "login.panel.description1" | translate }}
      </p>
      <p class="brand-panel__text">
        {{ "login.panel.description2" | translate }}
      </p>

      <ul class="brand-panel__features">
        <li>
          <span class="brand-panel__badge">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </span>
          <span>
            <strong>{{ "login.panel.feature1Title" | translate }}</strong>
            <small>{{ "login.panel.feature1Text" | translate }}</small>
          </span>
        </li>
        <li>
          <span class="brand-panel__badge">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="5" y="11" width="14" height="10" rx="2" />
              <path d="M8 11V7a4 4 0 0 1 8 0v4" />
            </svg>
          </span>
          <span>
            <strong>{{ "login.panel.feature2Title" | translate }}</strong>
            <small>{{ "login.panel.feature2Text" | translate }}</small>
          </span>
        </li>
      </ul>
    </div>
  </aside>

  <!-- Sign-in column -->
  <main class="signin">
    <div class="signin__body">
      <img
        src="assets/images/banknbox-wordmark.svg"
        [attr.alt]="'login.logoAlt' | translate"
        class="signin__logo"
      />

      @if (!resetPassword && !twoFactorAuthenticationRequired) {
        <h2 class="signin__title">{{ "login.signIn.title" | translate }}</h2>
        <p class="signin__subtitle">
          {{ "login.signIn.subtitle" | translate }}
        </p>
      }

      <div class="signin__form">
        @if (displayTenantSelector()) {
          <span class="signin__label">
            {{ "labels.inputs.Tenant" | translate }}
          </span>
          <LOSx-tenant-selector></LOSx-tenant-selector>
        }

        <!--
          Type of Form:
          Login
          Reset Password
          Two Factor Authentication
        -->
        @if (!resetPassword && !twoFactorAuthenticationRequired) {
          <LOSx-login-form></LOSx-login-form>
        }
        @if (resetPassword) {
          <LOSx-reset-password></LOSx-reset-password>
        }
        @if (twoFactorAuthenticationRequired) {
          <LOSx-two-factor-authentication></LOSx-two-factor-authentication>
        }
      </div>
    </div>

    <footer class="signin__footer">
      <div class="signin__meta">
        <img
          src="assets/images/banknbox-icon.svg"
          alt=""
          class="signin__meta-icon"
        />
        <div>
          <p>
            <span class="signin__env">{{
              environment.production ? "" : ("login.footer.staging" | translate)
            }}</span>
            {{ "login.footer.version" | translate }}: {{ environment.version }}
          </p>
          <p>
            © {{ currentYear }} {{ "login.panel.product" | translate }}
            <span class="signin__links">
              <button type="button" [matMenuTriggerFor]="resourcesMenu">
                {{ "labels.links.Resources" | translate }}
              </button>
              <button type="button" [matMenuTriggerFor]="supportMenu">
                {{ "labels.links.Support" | translate }}
              </button>
              <button type="button" [matMenuTriggerFor]="aboutMenu">
                {{ "labels.links.About" | translate }}
              </button>
            </span>
          </p>
        </div>
      </div>

      <div class="signin__tools">
        @if (allowServerSwitch()) {
          <LOSx-server-selector></LOSx-server-selector>
        }
        <LOSx-language-selector></LOSx-language-selector>
        <LOSx-theme-toggle></LOSx-theme-toggle>
        <button
          type="button"
          class="signin__reload"
          (click)="reloadSettings()"
          [attr.aria-label]="'login.footer.reload' | translate"
          [attr.title]="'login.footer.reload' | translate"
        >
          <fa-icon icon="refresh"></fa-icon>
        </button>
      </div>
    </footer>
  </main>
</div>

<!-- Contact Information/Resources Menus -->
<mat-menu #resourcesMenu="matMenu">
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.User Manual" | translate }}</a
  >
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.Documentation" | translate }}</a
  >
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.API Reference" | translate }}</a
  >
</mat-menu>

<mat-menu #supportMenu="matMenu">
  <a href="mailto:support@banknbox.com" target="_blank" mat-menu-item>{{
    "labels.links.Contact Support" | translate
  }}</a>
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.FAQ" | translate }}</a
  >
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.Training" | translate }}</a
  >
</mat-menu>

<mat-menu #aboutMenu="matMenu">
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.About Us" | translate }}</a
  >
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.Careers" | translate }}</a
  >
  <a
    href="https://www.banknbox.com/digital-banking"
    target="_blank"
    mat-menu-item
    >{{ "labels.links.Privacy Policy" | translate }}</a
  >
</mat-menu>
